export const LoadingModel =()=>{
 
    return  (
      <div className="flex justify-center items-center min-h-screen bg-black text-white">
        <div className="text-xl animate-pulse">Loading...</div>
      </div>
    );

}